/**
 * Member-facing events copy (MYN-97 / MYN-98).
 *
 * Feature-local rather than appended to `lib/constants/ui-strings.ts`, which is
 * already past the mnr-standards 400-LOC "yellow" threshold and carries a
 * `TODO(decompose)` asking for exactly this split.
 */
export const EVENTS_STRINGS = {
  /** Event detail page (Option B layout, 2026-10-14). */
  DETAIL: {
    BACK_TO_EVENTS: 'Back to Events',
    BACK_TO_DASHBOARD: 'Back to Dashboard',
    BACK_TO_HOME: 'Back to Home',
    REGISTERED: 'Registered',
    REGISTRATION_CLOSED: 'Registration Closed',
    REGISTRATION_CLOSES: 'Registration closes',
    ABOUT: 'About this event',
    /**
     * Heading above the partner logo (FR-281, MYN-184). The client asked for a
     * heading so "anyone looking at it knows that's why that logo is there";
     * the partner's name is deliberately NOT rendered as text beside it.
     */
    TRUSTED_PARTNER_HEADING: 'Trusted Partner for this event',
    FACT_DATE: 'Date',
    FACT_TIME: 'Time',
    FACT_LOCATION: 'Location',
    FACT_ORGANIZER: 'Organized by',
    ENDS_PREFIX: 'Ends',
  },
  /** Public (account-less) registration modal and join panel (FR-282 to FR-286, FR-289). */
  GUEST: {
    MODAL_TITLE: 'Register for this event',
    MODAL_DESCRIPTION: 'Enter your name and email and we will send you the event details.',
    FULL_NAME_LABEL: 'Full name',
    FULL_NAME_PLACEHOLDER: 'Jordan Lee',
    EMAIL_LABEL: 'Email',
    EMAIL_PLACEHOLDER: 'name@example.com',
    FULL_NAME_REQUIRED: 'Full name is required',
    FULL_NAME_TOO_LONG: 'Full name is too long',
    EMAIL_REQUIRED: 'Email is required',
    EMAIL_INVALID: 'Enter a valid email address',
    EMAIL_TOO_LONG: 'Email is too long',
    SUBMIT: 'Register',
    SUBMITTING: 'Registering…',
    SUCCESS_TITLE: "You're registered",
    SUCCESS_BODY: (email: string) => `We emailed the event details to ${email}.`,
    DONE: 'Done',
    ERROR_NOT_ACCEPTING: 'This event is not accepting registrations.',
    ERROR_RATE_LIMITED: 'Too many attempts. Please try again shortly.',
    ERROR_NETWORK: 'We could not reach the server. Check your connection and try again.',
    ERROR_GENERIC: 'We could not complete your registration. Please try again.',
    UNREGISTER: 'Unregister',
    UNREGISTER_SUCCESS: 'Your registration has been cancelled.',
    UNREGISTER_ERROR_RATE_LIMITED: 'Too many attempts. Please try again shortly.',
    UNREGISTER_ERROR_GENERIC: 'We could not cancel your registration. Please try again.',
    JOIN_TITLE: 'How to join',
    JOIN_LINK_LABEL: 'Join link',
    JOIN_ADDRESS_LABEL: 'Address',
  },
  /** Rendered uppercase by the badge itself (Figma 418:15516 sets `text-transform: uppercase`). */
  FEATURED_BADGE: 'Featured Event',
  REGISTER: 'Register',
  VIEW_DETAILS: 'View Details',
  /** One-tag labels on an event card (Featured uses FEATURED_BADGE). */
  TAG_REGISTERED: 'Registered',
  TAG_PUBLIC: 'Public',
  TAG_MEMBERS_ONLY: 'Members Only',
  EVENTS_PAGE_TITLE: 'Events',
  FEATURED_SECTION_TITLE: 'Featured Event',
  PUBLIC_SECTION_TITLE: 'Upcoming Events',
  PUBLIC_SECTION_SUBTITLE: 'Join a session with founders, investors, and our partner network.',
  /**
   * Shown when `GET /v1/events/public-section` comes back empty. Public pages
   * still render the section heading so the page structure does not jump.
   */
  PUBLIC_SECTION_EMPTY_TITLE: 'No upcoming events right now',
  PUBLIC_SECTION_EMPTY_BODY: 'Check back soon - new sessions are added regularly.',
  LOADING: 'Loading events…',
  LOAD_ERROR_TITLE: 'Events could not be loaded',
  LOAD_ERROR_BODY: 'Something went wrong fetching upcoming events. Please refresh the page.',
  /**
   * `PrivateEventRoute` (MYN-93, `/e/:id`). Deliberately minimal - the
   * detail page's real content and layout are MYN-51's deliverable, not
   * this ticket's; this is only the loading / not-available shell around
   * the anonymous-reachable read.
   */
  PRIVATE_EVENT_LOADING: 'Loading event…',
  // HANDLE row, verbatim: "/e/:id opened for an archived, cancelled, or
  // soft-deleted event - returns a structured 404 rather than a partial
  // page" / "Clear not-available message, no event detail".
  PRIVATE_EVENT_NOT_AVAILABLE_TITLE: 'This event is not available',
  PRIVATE_EVENT_NOT_AVAILABLE_BODY:
    'The event may have been removed, or the link may be incorrect.',
} as const;
